import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export async function getBrandAmbassadorsVerificationEmail(ambassadorId) {
  const query = `query ($ambassadorId:ID!) {
    brandAmbassador(ambassadorId:$ambassadorId) {
      emailVerificationLink
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    ambassadorId,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/gql.js